import React, { useRef, useEffect, useState } from 'react';
import { Button } from '../StyledComponents.js';
import { FaBars } from 'react-icons/fa';
import { FormattedMessage } from 'react-intl';

export default function HamburgerMenu({
  loggedIn,
  user,
  openLoginModal,
  openSignupModal,
  closeAllModals,
  onAccountClick,
  windowWidth
}) {
  const [menuOpen, setMenuOpen] = useState(false);
  const hamburgerRef = useRef();

  const handleHamburgerClick = () => {
    setMenuOpen((open) => !open);
  };

  const handleMenuAccountClick = () => {
    setMenuOpen(false);
    onAccountClick();
  };

  useEffect(() => {
    if (!menuOpen) return;
    function handleClickOutside(event) {
      if (hamburgerRef.current && !hamburgerRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [menuOpen]);

  return (
    <div style={{ position: 'relative' }} ref={hamburgerRef}>
      <FaBars
        className="ml-1"
        onClick={handleHamburgerClick}
        size={windowWidth < 576 ? '2.5em' : '2.2em'}
        style={{
          cursor: 'pointer',
          color: menuOpen ? '#ff9800' : '#333',
          transition: 'color 0.2s',
          padding: '6px',
          borderRadius: '50%',
          background: menuOpen ? 'rgba(255, 235, 59, 0.15)' : 'transparent',
          boxShadow: menuOpen ? '0 2px 8px rgba(0,0,0,0.10)' : 'none',
          outline: menuOpen ? '2px solid #ff9800' : 'none',
        }}
        aria-label="Menüyü aç/kapat"
        tabIndex={0}
        onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') handleHamburgerClick(); }}
      />
      {menuOpen && (
        <div style={{
          position: 'absolute',
          top: '2.7em',
          right: 0,
          background: 'white',
          boxShadow: '0 4px 16px rgba(0,0,0,0.18)',
          borderRadius: '12px',
          zIndex: 1000,
          minWidth: '160px',
          padding: '0.5em 0',
          animation: 'fadeInMenu 0.18s',
          border: '1px solid #eee',
        }}>
          {loggedIn ? (
            <>
              <div style={{
                width: '100%',
                padding: '0.7em 1.2em',
                color: '#888',
                fontSize: '0.98em',
                fontWeight: 500,
                borderBottom: '1px solid #f0f0f0',
                marginBottom: 2,
                background: '#fafafa',
                borderRadius: '8px 8px 0 0',
                letterSpacing: '0.01em',
              }}>
                👋 {user?.username}
              </div>
              <Button
                style={{
                  width: '100%',
                  textAlign: 'left',
                  background: 'none',
                  border: 'none',
                  color: '#333',
                  padding: '0.7em 1.2em',
                  fontSize: '1.05em',
                  borderRadius: '0',
                  transition: 'background 0.15s',
                }}
                onClick={handleMenuAccountClick}
                onMouseOver={e => e.currentTarget.style.background = '#f7f7f7'}
                onMouseOut={e => e.currentTarget.style.background = 'none'}
              >
                <FormattedMessage id="header.account" defaultMessage="Hesabım" />
              </Button>
            </>
          ) : (
            <>
              <Button
                style={{
                  width: '100%',
                  textAlign: 'left',
                  background: 'none',
                  border: 'none',
                  color: '#333',
                  padding: '0.7em 1.2em',
                  fontSize: '1.05em',
                  borderRadius: '0',
                  transition: 'background 0.15s',
                }}
                onClick={() => { setMenuOpen(false); openLoginModal(); }}
                onMouseOver={e => e.currentTarget.style.background = '#f7f7f7'}
                onMouseOut={e => e.currentTarget.style.background = 'none'}
              >
                <FormattedMessage id="header.signin" defaultMessage="Giriş Yap" />
              </Button>
              <Button
                style={{
                  width: '100%',
                  textAlign: 'left',
                  background: 'none',
                  border: 'none',
                  color: '#333',
                  padding: '0.7em 1.2em',
                  fontSize: '1.05em',
                  borderRadius: '0',
                  transition: 'background 0.15s',
                }}
                onClick={() => { setMenuOpen(false); closeAllModals(); openSignupModal() }}
                onMouseOver={e => e.currentTarget.style.background = '#f7f7f7'}
                onMouseOut={e => e.currentTarget.style.background = 'none'}
              >
                <FormattedMessage id="header.signup" defaultMessage="Kayıt Ol" />
              </Button>
            </>
          )}
        </div>
      )}
      <style>{`
        @keyframes fadeInMenu {
          from { opacity: 0; transform: translateY(-8px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}
